const sizes = {
  large: { h: '40', w: '40' },
  medium: { h: '32', w: '32' },
  small: { h: '24', w: '24' },
};

// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle
const _disabled = {
  background: 'transparent',
  cursor: 'not-allowed',
  opacity: '0.4',
};

const CloseButtonTheme = {
  baseStyle({
    colorScheme,
    size,
  }: {
    colorScheme: 'blue' | 'red' | 'orange' | 'yellow' | 'green' | 'purple' | 'neutral';
    size: 'small' | 'medium' | 'large';
  }) {
    if (colorScheme === 'neutral') {
      return {
        _active: { bg: 'neutral.90' },
        _hover: { bg: 'neutral.95' },
        bg: 'neutral.100',
        borderRadius: '4',
        color: 'purple.10',
        ...sizes[size],
        _disabled,
      };
    }
    return {
      _active: { bg: `${colorScheme}.90` },
      _hover: { bg: `${colorScheme}.93` },
      bg: `${colorScheme}.95`,
      borderRadius: '4',
      color: `${colorScheme}.40`,
      ...sizes[size],
      _disabled,
    };
  },
  defaultProps: { colorScheme: 'neutral', size: 'small' },
};
export default CloseButtonTheme;
